//import { io } from "socket.io-client";
 
export const url = process.env.REACT_APP_URL_API
/*
const urlsocket = process.env.REACT_APP_URL_API_SOCKET;
export const socket = io(urlsocket, {
  transports: ["websocket"],
});
*/